import React, { Component } from 'react';
import './RecordingsTable.css';
import { connect } from 'react-redux';
import XLSX from 'xlsx';
import ReactTable from 'react-table';
import debounce from 'lodash.debounce';
import Pagination from '@getgo/chameleon-react/dist/Pagination';
import { NavLink } from 'react-router-dom';
import { actions } from '../../../../Reducks/AdminRecordings/index';
import { CHECKBOX, VALUE_ADD } from '../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import {
  trackAnalyticsFeature,
  trackAnalyticsGenerateReportFeature
} from '../../../../Telemetry/Mixpanel/Features/analyticsTracker';
import { XLS } from '../../../../Utils/Constants';
import { HeaderSortComponent } from '../../../../Scss/Custom/ReactTable/HeaderSortComponent';
import { dateSorter, dayDateFormatterWithTimezone, getRecordingsData } from '../../../../Utils/TableUtil';
import { denormalizeRecordings } from '../../../../Reducks/Recordings/RecordingsUtils';
import { sessionsTableSkeletonScreen } from '../../../../SkeletonScreens/SkeletonScreen';
import PropTypes from 'prop-types';
import SimpleSearchBox from '../../../../Components/SearchBox/SimpleSearchBox';

import { RecordingSource } from '../../../../Utils/Constants';
import Menu from '../../../../Components/Menu/Menu';
import DownloadIcon from '../../../../Components/Buttons/DownloadIcon';
import { getReportTypeMenuItems } from '../../../../Components/Menu/MenuItemsHelper';
import { getUnion } from '../../../../Utils/ArrayUtils';

export class RecordingsTable extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    reportSource: PropTypes.array,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    }),
    recordings: PropTypes.object,
    filterRecordings: PropTypes.func,
    toggleRecording: PropTypes.func,
    toggleAllRecordings: PropTypes.func,
    recordingsData: PropTypes.object
  };
  constructor(props) {
    super(props);
    this.state = {
      searchText: ''
    };
    this._RecordingNameRefs = new Map();
  }

  getHeaders = () => {
    const { t } = this.context;
    const columns = this.getRecordingColumns();
    const header = [];
    columns.forEach(({ accessor }) => {
      switch (accessor) {
        case RecordingTableAccessor.NAME:
          header.push([t('tableHeaderColumns.name'), accessor]);
          break;
        case RecordingTableAccessor.ORGANIZER_NAME:
          header.push([t('tableHeaderColumns.organizers'), accessor]);
          break;
        case RecordingTableAccessor.DATE_UPLOADED:
          header.push([t('tableHeaderColumns.publishedDate'), accessor]);
          break;
        case RecordingTableAccessor.VIEW_COUNT:
          header.push([t('tableHeaderColumns.views'), accessor]);
          break;
        default:
          console.error('unexpected case');
          break;
      }
    });
    return header;
  };

  getRecords = (recordingsData, headers) => {
    const data = [];
    const { filteredKeys } = this.props.recordingsData;
    recordingsData.forEach(recording => {
      let row = [];
      if (filteredKeys.includes(recording.recordingKey)) {
        headers.forEach(element => {
          switch (element) {
            case RecordingTableAccessor.DATE_UPLOADED:
              row.push(dayDateFormatterWithTimezone(recording[element].dateTime, recording[element].timeZone));
              break;
            default:
              row.push(recording[element]);
          }
        });
        data.push(row);
      }
    });
    return data;
  };

  exportFile = (recordingsData, id) => {
    const { t } = this.context;
    const fileName = t('recordings.recordingsReportName');
    const headers = this.getHeaders();
    const records = this.getRecords(recordingsData, headers.map(item => item[1]));
    const data = getUnion([headers.map(item => item[0])], records);
    const workBook = XLSX.utils.book_new();
    const dataSheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(workBook, dataSheet);
    XLSX.writeFile(workBook, `${fileName}.${id === XLS ? 'xlsx' : 'csv'}`);
  };

  render() {
    const { fetching } = this.props.recordings;
    const recordings = this.props.recordingsData;
    const reportSource = this.props.reportSource;
    const filteredRecordings = denormalizeRecordings(recordings.filteredKeys, recordings.byKey);
    return (
      <div className="recordingsTableSection">
        {this.getSearchBar(filteredRecordings, reportSource)}
        {fetching ? sessionsTableSkeletonScreen() : this.getRecordingsTable(filteredRecordings, reportSource)}
      </div>
    );
  }

  getSelectedPageRecordings = page => {
    const { user } = this.props.reduced_user;
    const { filter } = this.props.recordings;
    this.props.getRecordings(
      user.accountKey,
      filter.fromTime,
      filter.toTime,
      filter.creators,
      this.state.searchText,
      page,
      20,
      false
    );
  };

  fetchPage = (page = 1) => {
    this.getSelectedPageRecordings(page - 1);
  };

  fetchPageDebounced = debounce(this.fetchPage, 500);

  getRecordingsTable = (filteredRecordings, reportSource) => {
    const { pagination, filtering } = this.props.recordings;
    const nextDisabled = typeof pagination.next !== 'number';
    const previousDisabled = typeof pagination.previous !== 'number';
    const showPagination = !(nextDisabled && previousDisabled);
    return (
      <div>
        <ReactTable
          keyField="recordingKey"
          data={getRecordingsData(filteredRecordings, reportSource)}
          columns={this.getRecordingColumns()}
          defaultPageSize={filteredRecordings.length}
          minRows={5}
          loading={filtering}
          style={{ height: '270px' }}
          showPagination={false}
          className="-highlight"
          defaultSorted={[{ id: 'dateUploaded', desc: true }]}
        />
        {showPagination && (
          <div className="pagination">
            <Pagination
              disableLast={false}
              key="event-pagination"
              lastPage={pagination.pageCount}
              nextDisabled={nextDisabled}
              onNextSelected={() => this.getSelectedPageRecordings(pagination.next)}
              onPageSelected={this.fetchPage}
              onPreviousSelected={() => this.getSelectedPageRecordings(pagination.previous)}
              pageIndex={pagination.page + 1}
              previousDisabled={previousDisabled}
            />
          </div>
        )}
      </div>
    );
  };

  getSearchBar = (filteredRecordings, reportSource) => {
    const { mixpanelData, uniqueId } = this.props;
    const { t } = this.context;
    const { isBig } = this.props;
    const detailsDownloadMenu = [];
    const menuDownloadItems = getReportTypeMenuItems();
    const recordingsData = getRecordingsData(filteredRecordings, reportSource);
    menuDownloadItems.map(item =>
      detailsDownloadMenu.push({
        onClick: () => this.exportFile(recordingsData, item.id),
        text: item.title,
        iconClassName: item.iconClass,
        id: item.id
      })
    );
    return (
      <div className="searchBoxContainer">
        <SimpleSearchBox
          searchString={this.props.recordings.filter.searchString}
          placeHolder={t('recordings.search')}
          onSearchInputChange={this.handleSearch}
          mixpanelData={mixpanelData}
        />
        <div className="d-flex justify-content-between align-items-center">
          <Menu
            isBig={isBig}
            menuKey={`download_${uniqueId}`}
            buttonName={t('buttons.downloadCamelCase')}
            detailsMenu={detailsDownloadMenu}
            buttonComponent={<DownloadIcon isBig={isBig} />}
          />
        </div>
      </div>
    );
  };

  handleSearch = value => {
    this.setState({ searchText: value.trim() }, this.fetchPageDebounced);
  };

  getRecordingColumns = () => {
    const { t } = this.context;
    const { filteredSelectedRecordingKeys, filteredKeys } = this.props.recordingsData;

    return [
      {
        accessor: '',
        Header: this.checkBoxHeaderFormatter(filteredKeys.length, filteredSelectedRecordingKeys.length),
        Cell: this.checkBoxCellFormatter,
        sortable: false,
        width: 67,
        resizable: false,
        style: { textAlign: 'center', paddingLeft: '12px' },
        headerStyle: { textAlign: 'center', paddingLeft: '12px' }
      },
      {
        accessor: RecordingTableAccessor.NAME,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.name')} />,
        Cell: this.recordingNameFormatter,
        minWidth: 200
      },
      {
        accessor: RecordingTableAccessor.ORGANIZER_NAME,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.organizers')} />,
        Cell: this.organizerFormatter,
        minWidth: 100
      },
      {
        accessor: RecordingTableAccessor.DATE_UPLOADED,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.publishedDate')} />,
        Cell: cell => dayDateFormatterWithTimezone(cell.value.dateTime, cell.value.timeZone),
        sortMethod: dateSorter
      },
      {
        accessor: RecordingTableAccessor.VIEW_COUNT,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.views')} />
      }
    ];
  };

  organizerFormatter = ({ original }) => {
    return (
      <div>
        <div>{original.organizerName}</div>
        <div className="organizerEmail">{original.organizerEmail}</div>
      </div>
    );
  };

  checkBoxHeaderFormatter = (totalCount, selectedCount) => {
    const checked = selectedCount !== 0;
    const isIntermediate = selectedCount !== 0 && selectedCount !== totalCount;
    const onCheck = e => {
      trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, CHECKBOX);
      if (this.props.mixpanelData.reportType) {
        trackAnalyticsGenerateReportFeature(this.props.mixpanelData.reportType, CHECKBOX);
      }
      this.props.toggleAllRecordings(e.target.checked);
    };
    const intermediate = input => {
      if (input) {
        input.indeterminate = isIntermediate;
      }
    };
    return <input type="checkbox" ref={intermediate} checked={checked} onChange={onCheck} />;
  };

  recordingNameFormatter = ({ original }) => {
    let recordingKey,
      recordingSource = null;

    if (original.recordingKey.endsWith('-g2s')) {
      recordingKey = original.recordingKey.replace('-g2s', '');
      recordingSource = RecordingSource.G2S;
    } else if (original.recordingKey.endsWith('-g2s-embedded')) {
      recordingKey = original.recordingKey.replace('-g2s-embedded', '');
      recordingSource = RecordingSource.G2S_EMBEDDED;
    } else {
      recordingKey = original.recordingKey;
      recordingSource = RecordingSource.G2W;
    }
    return <NavLink to={`/analytics/recordings/${recordingSource}/${recordingKey}`}>{original.name}</NavLink>;
  };

  checkBoxCellFormatter = ({ original }) => {
    return (
      <input
        type="checkbox"
        ref={c => this._RecordingNameRefs.set(original.recordingKey, c)}
        checked={this.props.recordingsData.filteredSelectedRecordingKeys.includes(original.recordingKey)}
        onChange={e => {
          trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, CHECKBOX);
          if (this.props.mixpanelData.reportType) {
            trackAnalyticsGenerateReportFeature(this.props.mixpanelData.reportType, CHECKBOX);
          }
          this.props.toggleRecording(original.recordingKey, e.target.checked);
        }}
      />
    );
  };
  scrollToRecordingInTable = (previousRecordingKey, newRecordingKey) => {
    if (newRecordingKey) {
      const node = this._RecordingNameRefs.get(newRecordingKey);
      try {
        const row = node.parentElement.parentElement.parentElement;
        const tableBodyNode = row.parentElement;
        tableBodyNode.scrollTop = row.offsetTop - 45;
        const { scrollX, scrollY } = window;
        node.focus({ preventScroll: true });
        window.scrollTo(scrollX, scrollY);

        return this;
      } catch (e) {}
    } else if (previousRecordingKey) {
      const node = this._RecordingNameRefs.get(previousRecordingKey);
      if (node) {
        node.blur();
      }
    }
  };
}

export default connect(
  state => ({
    recordings: state.reduced_admin_recordings,
    reduced_user: state.reduced_user
  }),
  {
    toggleRecording: actions.toggleAdminRecording,
    toggleAllRecordings: actions.toggleAllAdminRecordings,
    getRecordings: actions.getAdminRecordings
  }
)(RecordingsTable);

class RecordingTableAccessor {
  static get NAME() {
    return 'name';
  }
  static get ORGANIZER_NAME() {
    return 'organizerName';
  }
  static get DATE_UPLOADED() {
    return 'dateUploaded';
  }
  static get VIEW_COUNT() {
    return 'viewCount';
  }
}



// WEBPACK FOOTER //
// ./src/GoToWebinar/Admin/Recordings/Table/RecordingsTable.js